import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadDataSourceFlightFormats';
const loadDataSourceFlightFormatsArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['items'],
    loadResource: (inputPayload) => {
        return DataSourceResource.getSupportedFlightFormats(inputPayload.workspaceId, inputPayload.dataSourceType);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadDataSourceFlightFormatsEpicReducer = loadResourcesUtils(loadDataSourceFlightFormatsArgs);
// Reducer
export const dataSourceFlightFormatsReducer = (state = defaultReducerState, action) => {
    state = loadDataSourceFlightFormatsEpicReducer.reduxChange(state, action);
    return state;
};
export default dataSourceFlightFormatsReducer;

//# sourceMappingURL=DataSourceFlightFormats.ducks.js.map
